import { render } from "./VrsSignalsStatsOverview.vue?vue&type=template&id=a57c3aba&scoped=true"
import script from "./VrsSignalsStatsOverview.vue?vue&type=script&lang=js"
export * from "./VrsSignalsStatsOverview.vue?vue&type=script&lang=js"

import "./VrsSignalsStatsOverview.vue?vue&type=style&index=0&id=a57c3aba&scoped=true&lang=css"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a57c3aba"]])

export default __exports__